import { createStore, combineReducers } from 'redux'

import shoppingCartReducer from './shopping_cart'
import shipping from './checkout_shipping_store'


const appReducers = combineReducers({
  shopping_cart: shoppingCartReducer,
  checkout: shipping
});

const store = createStore(appReducers);

const ReduxStore = () => { return store; }

export default ReduxStore;



// WEBPACK FOOTER //
// ./app/javascript/store_front/app/reducers/index.js